export const keys = [
  ["ذ", "\u0651", "\u064d", "\u064b", "\u064f", "\u0650", "\u064e", "\u0652", "آ", "إ", "أ"],
  ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح", "ج", "د"],
  ["ش", "س", "ي", "ب", "ل", "ا", "ت", "ن", "م", "ك", "ط"],
  ["ئ", "ء", "ؤ", "ر", "لا", "ى", "ة", "و", "ز", "ظ"]
] as const;

export type Key = " " | "backspace" | (typeof keys)[number][number];
